export default __webpack_public_path__ + "static/media/wuproject.7687ef49.png";